import React from 'react'
import moment from 'moment-timezone'
import MaterialIcon from 'react-native-vector-icons/MaterialIcons'
import styled, { useTheme } from 'styled-components/native'

import DayTab from './dayTab'

const DayTabWrapper = styled.View`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

const StyledDot = styled(MaterialIcon)<{ $hasAvailabilities: boolean }>`
  opacity: ${({ $hasAvailabilities }) => ($hasAvailabilities ? 1 : 0)};
`

interface Props {
  day: moment.Moment
  selected: boolean
  hasAvailabilities: boolean
  onSelect: () => void
}

export const DayTabWithAvailability: React.FC<Props> = ({
  day,
  selected,
  hasAvailabilities,
  onSelect,
}) => {
  const theme = useTheme()

  return (
    <DayTabWrapper>
      <DayTab
        day={day}
        onSelect={onSelect}
        selected={selected}
        hasAvailabilities={hasAvailabilities}
      />
      <StyledDot
        name="fiber-manual-record"
        size={12}
        $hasAvailabilities={hasAvailabilities}
        color={theme.colors.success}
      />
    </DayTabWrapper>
  )
}

export default DayTabWithAvailability
